import type { SubscriptionDetails } from 'src/API'

export const STANDARD_PLAN_PRODUCT_IDS = [
	'prod_Q0BoHVvK9LzXej',
	'prod_QCC4LXj5cUIu1b',
	'prod_Q0BpaF5ppyGbxA',
	'prod_Sil8np96QAZWWj',
] as const

const standardPlanProductIdSet = new Set(STANDARD_PLAN_PRODUCT_IDS)

type SubscriptionAccessData = Pick<
	SubscriptionDetails,
	'isEnterpriseUser' | 'subscriptionStatus' | 'subscriptionProductId'
>

export function hasPremiumPageAccess(
	subscriptionData?: SubscriptionAccessData | null
) {
	if (!subscriptionData) {
		return false
	}
	if (subscriptionData.isEnterpriseUser) {
		return true
	}
	if (subscriptionData.subscriptionStatus === 'trial') {
		return true
	}

	const productId = subscriptionData.subscriptionProductId?.trim()
	if (!productId) {
		return false
	}

	return !standardPlanProductIdSet.has(
		productId as (typeof STANDARD_PLAN_PRODUCT_IDS)[number]
	)
}
